import ProjectService from "../core/services/ProjectService";
import ClientProvider from "./ClientProvider";

const ServiceProvider = {
    provideProjectService: () => {
        return new ProjectService(ClientProvider.provideProjectClient());
    }
}

export default ServiceProvider;